/* global inlineAttachment, localStorage */
import React, { Component } from 'react'
import cn from 'classnames'
import CodeMirror from 'codemirror'
import 'codemirror/mode/gfm/gfm'
import marked from 'marked'
import utils from '../../lib/utils'
import '../../vendor/inline-attachment'
import '../../vendor/codemirror.inline-attachment'
import Popover from '../ui/Popover'
import MarkdownHelp from '../help/MarkdownHelp'

export default class extends Component {
  state = {
    preview: false
  }

  componentDidMount () {
    this.editor = CodeMirror.fromTextArea(this.textarea, {
      mode: 'gfm',
      lineWrapping: true
    })
    this.editor.on('change', this.onChange)
    inlineAttachment.editors.codemirror4.attach(this.editor, {
      uploadUrl: utils.uploadUrl(),
      extraHeaders: {
        'Authorization': `token ${localStorage.getItem('accessToken')}`
      },
      uploadFieldName: 'file',
      jsonFieldName: 'message',
      progressText: '![Uploading file...]()',
      urlText: '![file]({filename})',
      errorText: 'Error uploading file'
    })
    // refresh after sheet animates
    setTimeout(() => this.editor.refresh(), 250)
  }

  componentWillReceiveProps (props) {
    if (this.editor && this.editor.getValue() !== props.value) {
      this.editor.setValue(props.value || '')
    }
  }

  componentDidUpdate () {
    this.editor && this.editor.refresh()
  }

  onChange = e => {
    this.props.onChange(e.getValue())
  }

  onHelp = e => {
    this.help.setState({showing: true, target: e.target})
  }

  onPreview = e => {
    this.setState(prevState => ({preview: !prevState.preview}))
  }

  render () {
    const {value} = this.props
    const {preview} = this.state
    const className = cn('content-editor', 'markdown', {preview})

    return <div className={className}>
      <div className='header'>
        <span className='title'>{preview ? 'Preview' : 'Markdown'}</span>
        <a className='btn-icon icon-small ion-ios-help-outline' onClick={this.onHelp} />
        <a className='btn-icon icon-small ion-ios-eye' onClick={this.onPreview} />
        <Popover ref={c => (this.help = c)} placement='bottom center'>
          <MarkdownHelp />
        </Popover>
      </div>
      <textarea ref={c => (this.textarea = c)} defaultValue={value} />
      <div className='preview-pane'>
        <div className='scroll' dangerouslySetInnerHTML={{__html: value ? marked(value) : ''}} />
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/MarkdownEditor.js